export default {"src":"/_next/static/media/email.37cbc08c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};